@if(isDisabled && showOnlyValueWhenDisabled)
{
<div class="flex items-center" [ngClass]="boxHeight">
    <p class="text-sm font-medium text-black">{{ (inputValue !== null && inputValue !== undefined) ? (inputValue |
        number:showCustomDecimals) : inputValue }}</p>
</div>
}
@else {
<div class="card flex flex-col justify-content-center w-full" [ngClass]="autoMarginTop">
    <label [for]="inputId" class="mb-2 text-sm font-medium text-black" [class.text-neutral-800]="isDisabled"
        *ngIf="labelText">{{
        labelText }}</label>

    <div class="relative flex items-center">
        @if(iconSrc)
        {
        <span class="absolute" [ngStyle]="getIconStyles()">
            <img [src]="iconSrc" [alt]="iconAltText" [ngStyle]="getIconSizeStyles()" />
        </span>
        <span class="absolute" [ngStyle]="getDividerStyles()">
            <div class="h-4 w-[1px] bg-border rounded-full"></div>
        </span>
        }
        <input pInputText [id]="inputId" [type]="showTextType" [placeholder]="placeholder"
            class="rounded-[10px] py-2 focus:ring-2 focus:ring-primary focus:outline-none w-full"
            [ngClass]="[inputType === 'password' ? 'pr-10' : 'pr-4', boxHeight, isDisabled ? 'hover:cursor-not-allowed' : '', (errorMessage || warningMessage) ? 'border-error border-2' : 'border border-border', bgColor]"
            [ngStyle]="getInputPaddingStyles()" [value]="rawInput" [disabled]="isDisabled"
            [class.text-neutral-800]="isDisabled" (input)="onInputChange($event)"
            [attr.aria-invalid]="warningMessage ? 'true' : null"
            [attr.aria-describedby]="warningMessage ? inputId + '-warning' : null" (blur)="onBlurFormat()"
            [autocomplete]="autocomplete" [title]="getTitle" />

        <!-- Calculator -->
        <app-mini-calculator *ngIf="allowCalculator" [disabled]="isDisabled" [prefill]="rawInput"
            (accept)="onCalcAccept($event)" (trackCalcExprHistoryChange)="onChildCalcExprChanged($event)">
        </app-mini-calculator>

    </div>

    <div *ngIf="errorMessage" [id]="inputId + '-error'" class="flex items-center text-error mt-2 text-sm">
        <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
            class="w-5 h-5" />
        <p class="ml-1">{{ errorMessage }}</p>
    </div>

    <div *ngIf="!errorMessage && warningMessage" [id]="inputId + '-warning'"
        class="flex items-center text-error mt-2 text-sm">
        <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
            class="w-5 h-5" />
        <p class="ml-1">{{ warningMessage }}</p>
    </div>
</div>
}